import { BreOrderType } from '~/tenants/bre/model/enums';

const BaseRates = {
  OUTDOOR_BACK: '200',
  OUTDOOR_FRONT: '200',
  OUTDOOR_BOTH: '250',
  OUTDOOR_BOTH_XL: '450',
  SITE_PLAN: '100',
};

export const BreMatterportRate: Record<BreOrderType, typeof BaseRates> = {
  [BreOrderType.COMMERCIAL]: {
    ...BaseRates,
    OUTDOOR_BOTH: '750',
    OUTDOOR_BOTH_XL: '1250',
  },
  [BreOrderType.RENTAL]: BaseRates,
  [BreOrderType.LONG_TERM]: BaseRates,
  [BreOrderType.RESIDENTIAL]: BaseRates,
  [BreOrderType.PROPERTY_MKTG]: BaseRates,
  [BreOrderType.AGENT_MKTG]: BaseRates,
};

const BasePays = {
  OUTDOOR_BACK: '130',
  OUTDOOR_FRONT: '130',
  OUTDOOR_BOTH: '162.5',
  OUTDOOR_BOTH_XL: '292.5',
  SITE_PLAN: '50',
};

export const BreMatterportPay: Record<BreOrderType, typeof BasePays> = {
  [BreOrderType.COMMERCIAL]: BasePays,
  [BreOrderType.RENTAL]: BasePays,
  [BreOrderType.LONG_TERM]: BasePays,
  [BreOrderType.RESIDENTIAL]: BasePays,
  [BreOrderType.PROPERTY_MKTG]: BasePays,
  [BreOrderType.AGENT_MKTG]: BasePays,
};
